<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Изменить текст массового сообщения</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="textMessage" persistent max-width="480">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Измените текст сообщения</v-card-title>
          <v-text-field
            ref="doorText"
            v-model="textNew"
            label="Введите текст"
            class="pa-5"
            outlined
            dense
            hide-details
            :rules="[
                      value => !!value || 'Обязательное поле',
                      value => !value || value.length > 0 || 'Сообщение не может быть пустым',
                    ]"
          ></v-text-field>
          <mass-schedule-fields v-model="schedule" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="textMessage = false"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              @click="uploadText"
              :loading="isloading"
              :disabled="textNew === '' || !isScheduleReady"
            >
              Загрузить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="updateResult && updateResult.message">
              <h3>{{ updateResult.message }}</h3>
            </v-col>
            <v-col v-else-if="issetRightDoorphones()">
              <h3>Успешно изменён на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-else-if="issetFailDoorphones()">
              <h3>Не удалось изменить на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';
import MassScheduleFields from '@/components/massFunction/components/MassScheduleFields.vue';
import { buildSchedulePayload } from '@/components/massFunction/utils/schedulePayload';

export default {
  name: 'TextMessage',
  components: { MassScheduleFields },
  props: ['doorphones'],
  data () {
    return {
      textMessage: false,
      isloading: false,
      textNew: '',
      dialogResult: false,
      updateResult: {},
      schedule: {
        useSchedule: false,
        startDate: '',
        endDate: '',
      },
    };
  },
  watch: {
    textMessage (open) {
      if (open) {
        this.resetSchedule();
      }
    },
  },
  computed: {
    isScheduleReady () {
      if (!this.schedule || !this.schedule.useSchedule) return true;
      return !!(this.schedule.startDate && this.schedule.endDate);
    },
  },
  methods: {
    ...mapActions({
      uploadMassTextmessage: 'Doorphone/uploadMassTextmessage',
    }),
    resetSchedule () {
      this.schedule = {
        useSchedule: false,
        startDate: '',
        endDate: '',
      };
    },
    uploadText () {
      this.$refs.doorText.validate(true);
      this.$nextTick(() => {
        if (this.textNew !== '') {
          const { payload, error } = buildSchedulePayload(this.schedule);
          if (error) {
            this.$flash_warning(error);
            return;
          }
          const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });

          this.isloading = true;
          const req = {
            text: this.textNew,
            doorphones: selectedDoorphoneId,
          };
          if (payload) {
            req.start_date = payload.start_date;
            req.end_date = payload.end_date;
          }
          this.uploadMassTextmessage(req)
            .then((res) => {
              this.textNew = '';
              this.resetSchedule();
              this.textMessage = false;
              this.updateResult = res;
              this.dialogResult = true;
            })
            .catch((error) => {
              this.$flash_warning('Не удалось изменить текст сообщения');
              console.error(error);
            })
            .finally(() => {
              this.isloading = false;
            });
        }
      });
    },
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
